import React, { useState, useEffect } from 'react';

export const SessionContext = React.createContext();

export default function SessionProvider(props) {
  const [loggedIn, setLoggedIn] = useState(false);
  const [user, setUser] = useState();
  const [shipping, setShipping] = useState();
  const [payment, setPayment] = useState();
  const [purchaseItem, setPurchaseItem] = useState();

  useEffect(() => {}, []);

  return (
    <SessionContext.Provider
      value={{
        loggedIn,
        shipping,
        setShipping,
        payment,
        setPayment,
        purchaseItem,
        setPurchaseItem,
        setLoggedIn,
        user,
        setUser,
      }}
    >
      {props.children}
    </SessionContext.Provider>
  );
}
